import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Paper from '@material-ui/core/Paper';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TablePagination from '@material-ui/core/TablePagination';
import TicketsTableHead from './TicketsTableHead';
import useStyles from './styles';
import TicketsTableBody from './TicketsTableBody';
import { rowsPerPageState, setRowsPerPage } from '../HomePage/HomeSlice';

export default function TicketsTable(props) {
  const { headCells, ticketList, rows, count, rowsPerPage, page } = props;
  const classes = useStyles();

  const dispatch = useDispatch();
  const oldRowsPerPage = useSelector(rowsPerPageState);

  const handleChangePage = (event, newPage) => {
    props.setPage(newPage);
  };

  useEffect(() => {
    if (oldRowsPerPage !== undefined && oldRowsPerPage.homeRows !== undefined) {
      props.setRowsPerPage(oldRowsPerPage.homeRows);
    }
  }, []);

  const handleChangeRowsPerPage = (event) => {
    props.setRowsPerPage(parseInt(event.target.value, 10));
    props.setPage(0);

    const data = { ...oldRowsPerPage };
    data.homeRows = parseInt(event.target.value, 10);

    dispatch(setRowsPerPage(data));
  };

  return (
    <Paper className={classes.paper}>
      <TableContainer className={classes.tableContainer}>
        <Table
          stickyHeader
          className={classes.table}
          classes={{ stickyHeader: classes.stickyHeader }}
          size="medium"
          aria-label="tickets-table"
        >
          <TicketsTableHead headCells={headCells} rows={ticketList} />
          <TicketsTableBody
            headCells={headCells}
            page={page}
            rowsPerPage={rowsPerPage}
            rows={rows}
          />
        </Table>
      </TableContainer>
      <TablePagination
        className={classes.paginationBox}
        classes={{
          selectIcon: classes.selectIcon,
          actions: classes.actions,
        }}
        rowsPerPageOptions={[5, 10, 15, 20, 30, 50]}
        component="div"
        count={count}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </Paper>
  );
}
